import { OfferList } from 'ui/components/agent/patterns/OfferList/OfferList';

/**
 * 仲介業者オファー一覧
 */
export const AgentOfferList: React.FC = () => {
    return <OfferList />;
};
